import { render, staticRenderFns } from "./UniversityAboutInfoReview.vue?vue&type=template&id=54223910"
import script from "./UniversityAboutInfoReview.vue?vue&type=script&lang=js"
export * from "./UniversityAboutInfoReview.vue?vue&type=script&lang=js"
import style0 from "./UniversityAboutInfoReview.vue?vue&type=style&index=0&id=54223910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports